export const experience = [
    {
      companyName: "Onpassive",
      Role: "Associate Software Engineer",
      years: "June 2023 - Present",
      discription: [
        "Built and improved video conferencing apps with React.js, Node.js, MongoDB, Socket.io, Redis and Serverless Framework",
        "Created new API based on requirment, backend code optimization for fast response.",
        "Contributed to project deadlines and enhanced application performance through effective project management techniques..",
      ],
    }
  ];